// extracted by mini-css-extract-plugin
export default {"productDiv":"product_productDiv__AQv7v","active":"product_active__1c3bD","titleDiv":"product_titleDiv__qMx66","discriptionArea":"product_discriptionArea__Gz6LE"};